<template>
    <div class="main-spinner" >
        <div class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
        </div>
    </div>
</template>

<script>
import loggingService from '../services/util/loggingService'

export default {
    name: 'spinner',
    data: function () {
        return {
            isDebug: false
        }
    },
    created () {
        loggingService.log(this.isDebug, 'Spinner', 'created')
    },
    mounted () {
        loggingService.log(this.isDebug, 'Spinner', 'mounted')
    }
}
</script>

<style>

.main-spinner{
    float: right;
    margin-top: 20px;
    width: 100px;
}

.spinner {
  margin: 0 auto 0;
  width: 70px;
  text-align: center;
}

.spinner > div {
  width: 18px;
  height: 18px;
  background-color: #364760;

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: bouncedelay 1.4s infinite ease-in-out;
  animation: bouncedelay 1.4s infinite ease-in-out;
  /* Prevent first frame from flickering when animation starts */
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes bouncedelay {
  0%, 80%, 100% { -webkit-transform: scale(0.0) }
  40% { -webkit-transform: scale(1.0) }
}

@keyframes bouncedelay {
  0%, 80%, 100% {
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  } 40% {
      transform: scale(1.0);
      -webkit-transform: scale(1.0);
    }
}

</style>



// WEBPACK FOOTER //
// Spinner.vue?3fff8d6d